<template>
    <div class="confirm-button">
        <button v-if="!link" @click="confirm" type="submit" v-bind:class="[classes,isLoading]" class="loader-btn">
            <div class="loader small white" style="margin-top: -29px;"></div>
            <div class="flex-center button-message">
                <div class="msg" v-html="!confirming ? value : message"></div>
                <div class="confirm" @click="cancel" v-if="this.confirming">
                    <span class="material-icons">highlight_off</span>
                </div>
            </div>
            <div  class="confirm-line" v-bind:class="{ active:confirming }">
                <div class="confirm-line-loader"></div>
            </div>
        </button>
        <div v-if="link" class="confirm-link">
            <a @click.prevent="confirmLink" v-if="!confirming" href="" class="link" v-bind:class="[classes,isLoading]" v-html="value"></a>
            <div v-if="confirming" class="confirm-message">
                <span v-html="confirmMessage"></span>
                <button type="submit" class="button tiny loader-btn">
                    <div class="loader small white" style="margin-top: -29px;"></div>
                    <div class="msg">Yes</div>
                </button>
                <a @click.prevent="cancel" href="" class="basic lighten">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script>
    module.exports = {
        data:function() {
            return {
                cancelling:false,
                confirming:false,
                confirmingTimeout:false,
                isConfirmed:false,
                isLoading:''
            }
        },
        props: {
            classes:{ type:String,default:'button medium block'},
            value: { type:String,default:'Submit'},
            timer:{type:Number,default:2000},
            message:{type:String,default:'Submitting'},
            confirmMessage:{type:String,default:'Are you sure?'},
            link:{type:Boolean,default:false}
        },
        methods: {
            confirm:function() {
                if(!this.cancelling && !this.confirming) {
                    this.confirming = true;
                    this.isLoading = 'confirming';
                    $(this.$el).find('.confirm-line-loader').animate({ width:'100%'},this.timer);
                    this.confirmingTimeout = setTimeout(function() {
                        this.confirmed();
                    }.bind(this),this.timer + 100);
                    event.preventDefault();
                } else if(!this.isConfirmed) {
                    event.preventDefault();
                } else {
                    this.confirming = false;
                    $(this.$el).find('.confirm-line-loader').css('width','0%');
                }
            },
            confirmLink:function() {
                this.confirming = true;
            },
            cancel:function() {
                this.cancelling = true;
                this.confirming = false;
                this.isLoading = '';
                this.isConfirmed = false;
                $(this.$el).find('.confirm-line-loader').stop(true,true).css('width','0px');
                clearTimeout(this.confirmingTimeout);
                setTimeout(function() {
                    this.cancelling = false;
                }.bind(this),50);
            },
            confirmed:function() {
                this.isConfirmed = true;
                this.isLoading = 'isLoading';
                $(this.$el).find('button').trigger('click');
            }
        },
        mounted:function() {

        }
    }
</script>
